import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Sparkles } from "lucide-react";
import { Link } from "react-router-dom";

/**
 * Tiny inline chip: "{N} CRM fields filled from conversations · {M} pending review".
 * Shown on Goldmine + MissedMoney headline rows. Clickable — jumps to the
 * shared /ghl/field-review queue.
 */
export default function FieldFillCounter({ testid = "field-fill-counter" }) {
  const [counter, setCounter] = useState(null);

  useEffect(() => {
    let active = true;
    const load = () =>
      api
        .get("/field-fills/counter")
        .then((r) => {
          if (active) setCounter(r.data || { written: 0, pending_review: 0 });
        })
        .catch(() => {
          if (active) setCounter({ written: 0, pending_review: 0 });
        });
    load();
    return () => {
      active = false;
    };
  }, []);

  if (!counter) return null;
  if ((counter.written || 0) === 0 && (counter.pending_review || 0) === 0) return null;

  return (
    <Link
      to="/employz/field-review"
      data-testid={testid}
      className="inline-flex items-center gap-1.5 text-[11px] uppercase tracking-[0.16em] px-2.5 py-1 rounded-full border border-emerald-500/30 bg-emerald-500/5 text-emerald-300 hover:border-emerald-400/60 transition-colors"
    >
      <Sparkles className="w-3 h-3" />
      <span data-testid={`${testid}-written`}>{counter.written || 0}</span>
      &nbsp;CRM fields filled
      {counter.pending_review > 0 && (
        <span className="ml-1 text-amber-300" data-testid={`${testid}-pending`}>
          · {counter.pending_review} to review
        </span>
      )}
    </Link>
  );
}
